import { render, staticRenderFns } from "./right.vue?vue&type=template&id=71ce1976&scoped=true"
import script from "./right.vue?vue&type=script&lang=js"
export * from "./right.vue?vue&type=script&lang=js"
import style0 from "./right.vue?vue&type=style&index=0&id=71ce1976&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ce1976",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ce1976')) {
      api.createRecord('71ce1976', component.options)
    } else {
      api.reload('71ce1976', component.options)
    }
    module.hot.accept("./right.vue?vue&type=template&id=71ce1976&scoped=true", function () {
      api.rerender('71ce1976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/designCategory/layout/right.vue"
export default component.exports